export const urlValidator = (urlString: string) => {
	let url;
	try {
		url = new URL(urlString);
	} catch (_) {
		return false;
	}
	return url.protocol === 'http:' || url.protocol === 'https:' || url.protocol === 'webcal:';
};
